









































































































import { Component, Vue } from "vue-property-decorator";
import reportStore from "@/store/reportsStore";
import { SuburbAndStreetsModel } from "@/api/Shared";
import { DATE_PICKER_FORMAT } from "@/Constants";
import format from "date-fns/format";
import ComboBox from "@/components/Forms/ComboBox.vue";
import Autocomplete from "@/components/Forms/Autocomplete.vue";
import DateRangePicker from "@/components/Forms/DateRangePicker.vue";
import { Observer } from "mobx-vue";
import { IObservableArray } from "mobx";
import { addDataCyToComboBox } from "@/UITestHelper/UITestHelper";

@Observer
@Component({ components: { ComboBox, Autocomplete, DateRangePicker } })
export default class ReportFilters extends Vue {
  reportStore = reportStore;

  searchSuburbs(query: string) {
    if (!query) return [];

    const matches = reportStore.suburbs.filter(s => s?.suburbName.toUpperCase().indexOf(query.toUpperCase()) >= 0);

    return matches;
  }

  searchStreets(query: string) {
    if (!query) return [];
    const getStreetsFromSuburbs = (sourceSuburbs: SuburbAndStreetsModel[]): string[] => {
      const allStreets = sourceSuburbs.map(s => (s.streetNames as IObservableArray<string>).toJS()).reduce((a, b) => a.concat(b), []);
      const distinctStreets = new Set(allStreets);
      return Array.from(distinctStreets).sort();
    };

    const streetNames =
      !this.reportStore.filters.suburbs || this.reportStore.filters.suburbs.length === 0
        ? getStreetsFromSuburbs(reportStore.suburbs)
        : getStreetsFromSuburbs(reportStore.filters.suburbs);

    const matches = streetNames.filter(s => s && s.toUpperCase().indexOf(query.toUpperCase()) >= 0);
    return matches;
  }

  clearCache() {
    const myAuto1 = this.$refs.mySuburbs as Autocomplete;
    const myAuto2 = this.$refs.myStreets as Autocomplete;
    myAuto1.clearCache();
    myAuto2.clearCache();
  }

  get today() {
    return format(new Date(), DATE_PICKER_FORMAT);
  }

  mounted() {
    addDataCyToComboBox();
  }
}
